import { render, staticRenderFns } from "./EstateCard.vue?vue&type=template&id=8c0e1484&scoped=true&"
import script from "./EstateCard.vue?vue&type=script&lang=js&"
export * from "./EstateCard.vue?vue&type=script&lang=js&"
import style0 from "./EstateCard.vue?vue&type=style&index=0&id=8c0e1484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0e1484",
  null
  
)

export default component.exports